const gtmId = import.meta.env.VITE_GTM_ID;
if (!gtmId) {
  throw new Error('Missing GTM ID');
}

const apiBaseUrl = import.meta.env.VITE_FUNDAY_BASE_URL;
if (!apiBaseUrl) {
  throw new Error('Missing VITE_FUNDAY_BASE_URL');
}

const campusUrl = import.meta.env.VITE_CAMPUS_URL;
const fqUrl = import.meta.env.VITE_FQ_URL;
const officialUrl = import.meta.env.VITE_FUNDAY_OFFICIAL_URL;
const officialPublicImageUrl = import.meta.env.VITE_OFFICIAL_PUBLIC_IMAGE_URL;
const officialPublicV2ImageUrl = import.meta.env.VITE_OFFICIAL_PUBLIC_V2_IMAGE_URL;
const b2bOfficialUrl = import.meta.env.VITE_FUNDAY_B2B_OFFICIAL_URL;
const radioAudioUrl =
  import.meta.env.VITE_RADIO_AUDIO_URL ??
  'https://newradio.funday.asia/listen/funday_radio/radio.mp3';
const officialV2Url = import.meta.env.VITE_FUNDAY_V2_OFFICIAL_URL;
const socialUrl = import.meta.env.VITE_FUNDAY_SOCIAL_URL ?? 'https://social.funday.asia';
const aiTutorUrl = import.meta.env.VITE_FUNDAY_AI_TUTOR_URL ?? 'https://avatar.funday.asia';

export const env = {
  gtmId,
  apiBaseUrl,
  campusUrl,
  fqUrl,
  officialUrl,
  officialPublicImageUrl,
  officialPublicV2ImageUrl,
  b2bOfficialUrl,
  radioAudioUrl,
  officialV2Url,
  socialUrl,
  aiTutorUrl
};
